import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findProvinces = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces${query}`,
    {
      headers,
    },
  );
};

export const findProvinceById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces/${id}`,
    {
      headers,
    },
  );
};

export const createProvince = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces`,
    data,
    {
      headers,
    },
  );
};

export const updateProvince = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteProvince = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteProvinces = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/provinces?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
